__turbopack_context__.v({
  "richTextContent": "we4Cuq_richTextContent",
  "trustpilotWrapper": "we4Cuq_trustpilotWrapper",
});
